import React, { useState, useEffect } from 'react';
import { useClient } from 'jsonapi-react';
import { Link } from 'react-router-dom';
import Chart from '../Admin/Chart';
import { WidgetKpi, WidgetKpiValue } from '@/components/custom/widget';
import ChartWidget from '@/components/custom/widget-legacy/ChartWidget';
import { Loader } from '@/components/custom/loader';
import { useProgramOfStudies } from '@/hooks/useProgramOfStudies';
import { TabNavbar } from './TabNavbar';
import { t } from 'i18next';
import { DashboardContent } from '@/layouts/dashboard';
import { TaxonomiesItem, TaxonomiesList, TaxonomiesText } from '@/components/custom/taxonomies';

export const QuestionsDatabase = () => {
  const client = useClient();
  const { firstLevelTaxonomies, selectedTaxonomy, changeSelectedTaxonomy, fetchTaxonomies, selectingTaxonomy, loading } = useProgramOfStudies();
  const [dashboardData, setDashboardData] = useState();
  const [loadingDashboard, setLoadingDashboard] = useState(true);

  const fetchDashboard = async () => {
    try {
      if (selectedTaxonomy) {
        const { data } = await client.fetch(`reports/dashboard_questions/${selectedTaxonomy.id}`);
        setDashboardData(data);
        setLoadingDashboard(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, [selectedTaxonomy]);

  useEffect(() => fetchTaxonomies(), []);

  return (
    <DashboardContent variant="plain">
      <TabNavbar selectedTab="banco-de-questoes" />

      <div className="tab__pane">
        <div className="page page--wrap">
          <div className="page__aside">
            {selectingTaxonomy ? (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <Link
                to="#"
                className="btn btn--outline btn--full mb-6"
                style={{ borderColor: 'lightGray', color: 'gray' }}
              >
                Gerenciar banco de questões
              </Link>
            ) : (
              <Link
                to="/ementa/questoes-publicas"
                className="btn btn--outline btn--full mb-6"
              >
                Gerenciar banco de questões
              </Link>
            )}

            {loading ? (
              <Loader />
            ) : (
              <TaxonomiesList>
                {firstLevelTaxonomies &&
                  selectedTaxonomy &&
                  firstLevelTaxonomies.map((taxonomy, index) => (
                    <TaxonomiesItem
                      key={index}
                      active={taxonomy.id === selectedTaxonomy.id}
                      onClick={() => changeSelectedTaxonomy(taxonomy)}
                    >
                      <TaxonomiesText>{taxonomy.name}</TaxonomiesText>
                    </TaxonomiesItem>
                  ))}
              </TaxonomiesList>
            )}
          </div>

          <div className="page__content">
            {loadingDashboard && <Loader />}
            {dashboardData && (
              <>
                <h3 className="page__title">{selectedTaxonomy.name}</h3>

                <WidgetWrapper space="sm">
                  <WidgetKpi
                    title="Índice de Acerto"
                    variant="light"
                  >
                    <WidgetKpiValue>{dashboardData.correctAnswerPercent}%</WidgetKpiValue>
                  </WidgetKpi>

                  <WidgetKpi
                    title={t('nps.totalResponses')}
                    variant="light"
                  >
                    <WidgetKpiValue>{dashboardData.countAnswer}</WidgetKpiValue>
                  </WidgetKpi>

                  <WidgetKpi
                    title={t('nps.totalQuestions')}
                    variant="light"
                  >
                    <WidgetKpiValue>{dashboardData.countQuestion}</WidgetKpiValue>
                  </WidgetKpi>
                </WidgetWrapper>

                <WidgetWrapper space="sm">
                  <WidgetKpi
                    title="Respostas Fáceis"
                    variant="success"
                  >
                    <WidgetKpiValue>
                      {dashboardData.difficultyAnswers.easy.count} • {dashboardData.difficultyAnswers.easy.percent}%
                    </WidgetKpiValue>
                  </WidgetKpi>

                  <WidgetKpi
                    title="Respostas Médias"
                    variant="info"
                  >
                    <WidgetKpiValue>
                      {dashboardData.difficultyAnswers.mean.count} • {dashboardData.difficultyAnswers.mean.percent}%
                    </WidgetKpiValue>
                  </WidgetKpi>

                  <WidgetKpi
                    title="Respostas difíceis"
                    variant="danger"
                  >
                    <WidgetKpiValue>
                      {dashboardData.difficultyAnswers.hard.count} • {dashboardData.difficultyAnswers.hard.percent}%
                    </WidgetKpiValue>
                  </WidgetKpi>
                </WidgetWrapper>

                <WidgetWrapper variant="chart">
                  <ChartWidget title="Rendimento dos alunos ao longo do tempo">
                    {dashboardData && (
                      <Chart
                        name="Rendimento"
                        color="#FDB462"
                        chartData={dashboardData.studentPerformance}
                        valueSuffix="%"
                      />
                    )}
                  </ChartWidget>
                </WidgetWrapper>
              </>
            )}
          </div>
        </div>
      </div>
    </DashboardContent>
  );
};
